<template>
  <div class="goodList" ref="container">
    <router-link :to="{ path: '/points/detail/' + item.id }" class="item acea-row row-between-wrapper"
      v-for="(item, index) in pointsList" :key="index">
      <div class="pictrue">
        <img :src="item.image" class="image" />
        <img src="@assets/images/one.png" class="numPic" v-if="isSort === true && index === 0" />
        <img src="@assets/images/two.png" class="numPic" v-if="isSort === true && index === 1" />
        <img src="@assets/images/three.png" class="numPic" v-if="isSort === true && index === 2" />
      </div>
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.store_name }}</div>

          <div class="money font-color-red">
            <span v-show="item.score !== '请先登录'"></span>
            <span class="num">{{ item.score }}积分</span>
          </div>
          <div class="vip-money acea-row row-middle">

            <div class="vip" v-if="item.ot_price">
              <span v-show=" item.ot_price !=='请先登录'"></span>市场价: {{ item.ot_price || 0
              }}
            </div>


            <span class="num">剩余: {{ item.stock - item.sales }}</span>
          </div>

        </div>
      </div>
      <div>
        <van-button type="danger" class="exchange-btn" size="small">立即兑换</van-button>
      </div>
    </router-link>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Loading from "@components/Loading";
  import {
    Button
  } from 'vant';
  import {
    pointpro_list
  } from '@/api/store.js'
  Vue.use(Button);
  export default {

    name: 'PointsList',
    components: {
      Loading
    },
    props: {},
    data: function () {
      return {
        page: 1,
        limit: 8,
        loading: false,
        loadend: false,
        pointsList: []
      };
    },
    mounted() {
      this.getPointsList()
      this.$scroll(this.$refs.container, () => {
        !this.loading && this.getPointsList();
      });
    },
    methods: {
      getPointsList() {
        let that = this
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        pointpro_list({
          page: this.page,
          limit: this.limit
        }).then((res) => {
          that.loading = false;
          // // console.log(res, 'res')
          that.pointsList.push.apply(that.pointsList, res.data.list);
          that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
          that.page = that.page + 1;
        })
      }
    },
  }
</script>

<style scoped>
  .goodList .item .text {
    width: 3rem;
  }

  .exchange-btn {
    margin-right: 1em;
    margin-top: 4em;
  }

  .num {
    color: #666
  }

  .vip {
    text-decoration: line-through;
    color: #666
  }
</style>
